import ProductSearchAbstract from './ProductSearchAbstract';
import { ParamPair } from '../../lib/ParamPairs';

import Lightbox from '../Lightbox/Lightbox';
import Accordion from '../Accordion/Accordion';

// NOTE: The mobile version could be reworked to use Ajax, but plans explicitly recommend
// sticking to loading in the new page. -SB 2017-11-17

export default class ProductSearchMobile extends ProductSearchAbstract {
	private lightbox: Lightbox;
	private accordion: Accordion;

	constructor() {
		super();
		this.buildHandlers();

		// NOTE: Implementing the mobile version is where things started to get convoluted!
		// Refactoring may be a good idea. -SB 2017-11-17
		this.lightbox = new Lightbox(this.lightboxOptions);
	}

	private lightboxOptions: any = {
		heading: 'Filter By',
		target: 'productSearchAside__inner',
		triggerClass: 'productSearch__filterLightboxTrigger',
		onFirstOpen: () => {
			this.accordion = new Accordion('filterHeading', 'filterGroup');
			this.buildFilterTray(
				'asideMobileControls', {
					excludedQueries: this.excludedParams,
					clearFiltersEl: this.lightbox.el.getElementsByClassName('asideMobileControls__clear')[0],
					clearFiltersCB: (event: Event) => {
						const lightboxApplyBtn: Element = this.lightbox.el.getElementsByClassName('asideMobileControls__apply')[0];
						const filterCountEl: Element = lightboxApplyBtn.getElementsByClassName('asideMobileControls__apply--filterCount')[0];
						const excludedQueries: ParamPair[] = [{ name: 'q' }];

						this.updateFilterCount(filterCountEl, excludedQueries);
					}
				});
		},
		onOpen: () => {
			const lightboxApplyBtn: Element = this.lightbox.el.getElementsByClassName('asideMobileControls__apply')[0];
			const filterCountEl: Element = lightboxApplyBtn.getElementsByClassName('asideMobileControls__apply--filterCount')[0];

			const excludedQueries: ParamPair[] = [{ name: 'q' }];

			this.updateFilterCount(filterCountEl, excludedQueries);
			const updateFilterCountCB: EventListener = (event: Event): void => {
				this.updateFilterCount(filterCountEl, excludedQueries);
				this.updateApplyButton(lightboxApplyBtn);
			};

			const lightboxInputListener: EventListener = (event: Event): void => {
				let updatedEl: HTMLInputElement = event.target as HTMLInputElement;
				const elName: string = updatedEl.name;
				const elVal: string = updatedEl.value;
				const elId: string = updatedEl.id;
				const elType: string = updatedEl.type;
				// NOTE: The split is to grab only the text, not the quantity -SB 2017-12-05
				const elLabel: string = this.lightbox.el.querySelector(`[for="${elId}"]`).textContent.split('(')[0];

				// NOTE: This is very similar to the one for the desktop
				// version. Can they be merged? -SB 2017-11-17
				if (updatedEl.tagName === 'SELECT') {
					this.params.update(elName, elVal);
					this.ga.trackEvent('Product Search Filter', 'Select', `${elLabel}`);
				} else if (elType === 'radio') {
					this.params.update(elName, elVal);
					this.ga.trackEvent('Product Search Filter', 'Select', `${elLabel}`);
				} else if (elType === 'checkbox') {
					updatedEl = <HTMLInputElement>updatedEl;

					if (updatedEl.checked) {
						this.params.add(elName, elVal);
						this.ga.trackEvent('Product Search Filter', 'Select', `${elLabel}`);
					} else {
						this.params.removeValue(elName, elVal);
					}
				}

				this.updateFilterCount(filterCountEl, excludedQueries);
				this.updateApplyButton(lightboxApplyBtn);
			};

			const lightboxInputEl: HTMLCollectionOf<HTMLInputElement> = this.lightbox.el.getElementsByTagName('input');
			for (let index: number = 0; index < lightboxInputEl.length; index++) {
				const element: HTMLInputElement = lightboxInputEl[index];
				element.addEventListener('click', lightboxInputListener);
			}

			// Attach page update button to 'Apply' button
			const applyLightboxFilters: EventListener = (event: Event) => {
				const newURL: string = lightboxApplyBtn.getAttribute('data-href');
				if (newURL !== window.location.href) {
					window.location.href = newURL;
				} else {
					this.lightbox.close();
				}
			};
			lightboxApplyBtn.addEventListener('click', applyLightboxFilters);
			document.addEventListener('filtersCleared', updateFilterCountCB);

			// Attach clear handler to 'Clear' button
			const lightboxClearBtn: Element = document.getElementsByClassName('asideMobileControls__clear')[0];
			const clearLightboxFilters: EventListener = this.clearFiltersInScope(this.lightbox.el, updateFilterCountCB) as EventListener;
			lightboxClearBtn.addEventListener('click', clearLightboxFilters);
		}
	};

	protected updateFilterCount(filterCountEl: Element, excludedQueries?: ParamPair[]): void {
		const filterCount: number = this.params.filteredValueCount({excludedPairs: excludedQueries});
		if (filterCount) {
			filterCountEl.textContent = `${filterCount}`;
		} else {
			filterCountEl.textContent = '';
		}
	}

	protected updateApplyButton(applyButtonEl: Element): void {
		const newURL: string = this.params.buildQueryString();
		applyButtonEl.setAttribute('data-href', newURL);
	}

	private buildHandlers(): void {
		const sortInputEl: HTMLSelectElement = document.getElementById('sort') as HTMLSelectElement;
		const sortChangeListener: EventListener = (event: Event) => {
			const updatedEl: HTMLSelectElement = event.target as HTMLSelectElement;

			this.params.update(updatedEl.name, updatedEl.value);
			const newURL: string = this.params.buildQueryString();
			window.location.href = newURL;
		};
		sortInputEl.addEventListener('change', sortChangeListener);
	}
}